/**
 * @ngdoc module
 * @name flowingly.components
 * @module flowingly.components
 * @requires templates-components
 * @description Shared Components
 *
 * ###Notes
 * This module could be split into sub modules as it grows
 */

import angular from 'angular';
import ProcedureActionImageBridge from './Procedures/ProcedureActionImageBridge';
import ProcedureActionImageViewBridge from './Procedures/ProcedureActionImageViewBridge';
import CustomTabsBridge from './CustomTabs/CustomTabsBridge';
import { TextButtonBridge } from './buttons/TextButtonBridge';
import CountdownTimerBridge from './CountdownTimer/CountdownTimerBridge';
import { IconButtonBridge } from './buttons/IconButtonBridge';

const componentsModule = angular.module('flowingly.components', [
  'kendo.directives',
  'templates-components'
]);

componentsModule
  .component('procedureActionImage', ProcedureActionImageBridge)
  .component('procedureActionImageView', ProcedureActionImageViewBridge)
  .component('customTabs', CustomTabsBridge)
  .component('textButton', TextButtonBridge)
  .component('countdownTimer', CountdownTimerBridge)
  .component('iconButton', IconButtonBridge);

componentsModule.run([
  '$templateCache',
  function ($templateCache: angular.ITemplateCacheService) {
    // comments
    $templateCache.put(
      'add-comment.tmpl.html',
      require('./comments/add-comment.tmpl.html').default
    );

    $templateCache.put(
      'comment-history.tmpl.html',
      require('./comments/comment-history.tmpl.html').default
    );

    $templateCache.put(
      'comments.tmpl.html',
      require('./comments/comments.tmpl.html').default
    );

    // mention
    $templateCache.put(
      'flowingly.mention-search-list.tmpl.html',
      require('./mention/flowingly.mention-search-list.tmpl.html').default
    );
    $templateCache.put(
      'flowingly.mention.tmpl.html',
      require('./mention/flowingly.mention.tmpl.html').default
    );

    $templateCache.put(
      'table.runner.component.tmpl.html',
      require('./tablerunner/table.runner.component.tmpl.html').default
    );

    $templateCache.put(
      'table.viewer.component.tmpl.html',
      require('./tableviewer/table.viewer.component.tmpl.html').default
    );

    $templateCache.put(
      'table.builder.component.tmpl.html',
      require('./tablebuilder/table.builder.component.tmpl.html').default
    );

    $templateCache.put(
      'table.builder.cell.component.tmpl.html',
      require('./tablebuilder/table.builder.cell.component.tmpl.html').default
    );
    $templateCache.put(
      'table.builder.cell.editor.component.tmpl.html',
      require('./tablebuilder/table.builder.cell.editor.component.tmpl.html')
        .default
    );

    $templateCache.put(
      'customdatabase.config.component.tmpl.html',
      require('./customdatabase/customdatabase.config.component.tmpl.html')
        .default
    );

    $templateCache.put(
      'formula.config.component.tmpl.html',
      require('./formula/formula.config.component.tmpl.html').default
    );

    $templateCache.put(
      'lookup.config.component.tmpl.html',
      require('./lookup/lookup.config.component.tmpl.html').default
    );

    $templateCache.put(
      'table.runner.date.tmpl.html',
      require('./tablerunner/table.runner.date.tmpl.html').default
    );

    $templateCache.put(
      'table.runner.fileUpload.tmpl.html',
      require('./tablerunner/table.runner.fileUpload.tmpl.html').default
    );

    $templateCache.put(
      'dialog.warning.box.component.tmpl.html',
      require('./dialogwarningbox/dialog.warning.box.component.tmpl.html')
        .default
    );

    $templateCache.put(
      'icon.picker.component.tmpl.html',
      require('./icon.picker.component.tmpl.html').default
    );

    $templateCache.put(
      'editor.youtube.dialog.component.tmpl.html',
      require('./editor.youtube.dialog.component.tmpl.html').default
    );

    $templateCache.put(
      'flowingly.datepicker.tmpl.html',
      require('./datepicker/flowingly.datepicker.tmpl.html').default
    );
  }
]);
